import React, { useState } from "react"

import { useRecoilValue } from "recoil"

import { calculatedUtilityRateState } from "~/containers/Proposal/state/utility-costs-and-savings/utility-costs-and-savings-state"
import { TextInput } from "~/ui/lib/input/TextInput"

import {
  getSecondaryButtonStyles,
  getPrimaryButtonStyles,
} from "./shared/button-styles"
import type { AnnualUsageData } from "./types"
import { UtilityRateEditor } from "./UtilityRateEditor"

interface AnnualUsageFormProps {
  onSubmit: (data: AnnualUsageData) => void
  onCancel: () => void
  isLoading?: boolean
  canEdit?: boolean
}

export const AnnualUsageForm: React.FC<AnnualUsageFormProps> = ({
  onSubmit,
  onCancel,
  isLoading = false,
  canEdit = true,
}) => {
  const [annualUsage, setAnnualUsage] = useState(``)
  const utilityRate = useRecoilValue(calculatedUtilityRateState)

  const handleSubmit = () => {
    if (!canEdit) return

    if (annualUsage && parseFloat(annualUsage) > 0 && utilityRate > 0) {
      onSubmit({ annualUsage })
    }
  }

  const isValid = annualUsage && parseFloat(annualUsage) > 0 && utilityRate > 0

  return (
    <div className="w-full">
      <h3
        className="text-base font-bold leading-[22px] tracking-[0.75px] capitalize text-[var(--blue-dark)]"
        style={{ marginBottom: `24px`, fontSize: `18px` }}
      >
        Annual Usage
      </h3>

      <UtilityRateEditor className="mb-6" canEdit={canEdit} />

      <div className="mb-8">
        <TextInput
          id="annual-usage"
          label="Annual Usage (kWh)"
          type="number"
          value={annualUsage}
          onChange={(e) => setAnnualUsage(e.target.value)}
          placeholder="10000"
          disabled={isLoading || !canEdit}
        />
      </div>

      <div className="flex justify-end gap-3">
        <button
          type="button"
          onClick={onCancel}
          disabled={isLoading || !canEdit}
          style={getSecondaryButtonStyles(isLoading || !canEdit)}
        >
          Back
        </button>
        <button
          type="button"
          onClick={handleSubmit}
          disabled={!isValid || isLoading || !canEdit}
          style={getPrimaryButtonStyles(!isValid || isLoading || !canEdit)}
        >
          {isLoading ? `Generating Profile...` : `Generate Profile`}
        </button>
      </div>
    </div>
  )
}
